module.exports = __webpack_public_path__ + "static/media/login.4d5e1934.png";